"use strict";
/* eslint-disable functional/no-class */
/* eslint-disable functional/prefer-readonly-type */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentFormProfileFetch = exports.buildPaymentFormAddressData = exports.paymentFormForkedFetch = exports.paymentFormFetch = void 0;
const transformObject_1 = __importDefault(require("@simplisafe/ewok/transformObject"));
const fluture_1 = require("fluture");
const isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
const monet_1 = require("monet");
const prop_1 = __importDefault(require("ramda/src/prop"));
const config_1 = require("../config");
const perimeterX_1 = __importDefault(require("../perimeterX"));
const commercetools_1 = require("../secrets/commercetools");
const errorLogging_1 = require("../thirdparty/errorLogging");
const fluture_utils_1 = require("../utils/fluture-utils");
const requestHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
};
/** @deprecated **/
const paymentFormFetch = 
// TODO this shouldn't be a generic, but keeping it here to keep compatibility with frontend code
(request) => {
    const fetchOptions = buildFetchOptions(request);
    return (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(`${commercetools_1.paymentFormUrl}/${request.endpoint}`, fetchOptions))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody))
        .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull))
        .pipe((0, fluture_1.chainRej)(perimeterX_1.default));
};
exports.paymentFormFetch = paymentFormFetch;
/** @deprecated **/
const paymentFormForkedFetch = 
// TODO this shouldn't be a generic, but keeping it here to keep compatibility with frontend code
(request) => (handleFailure) => (handleSuccess) => {
    (0, exports.paymentFormFetch)(request)
        .pipe((0, fluture_1.fork)((e) => {
        (0, errorLogging_1.logError)(e);
        handleFailure && handleFailure(e);
    })(handleSuccess));
};
exports.paymentFormForkedFetch = paymentFormForkedFetch;
const buildFetchOptions = (params) => {
    return {
        body: JSON.stringify(params.payload),
        headers: requestHeaders,
        method: params.method
    };
};
/** @deprecated **/
exports.buildPaymentFormAddressData = (0, transformObject_1.default)({
    address: (0, transformObject_1.default)({
        city: (0, prop_1.default)('city'),
        postalCode: (0, prop_1.default)('postalCode'),
        // for some reason it seems like state is sometimes an empty string on the UK site. in that case, fall back to undefined.
        state: a => (0, prop_1.default)('state', a) || undefined,
        street: (0, prop_1.default)('streetName'),
        street2: (0, prop_1.default)('additionalStreetInfo')
    }),
    customer: (0, transformObject_1.default)({
        email: (0, prop_1.default)('email'),
        firstName: (0, prop_1.default)('firstName'),
        lastName: (0, prop_1.default)('lastName')
    })
});
/** @deprecated **/
const paymentFormProfileFetch = (chaseToken, transactionSecret, userId) => {
    const fetchOptions = {
        body: JSON.stringify({
            ctoken: chaseToken,
            // transaction_secret is only required for UK
            // eslint-disable-next-line camelcase -- api endpoint takes a snake_case param
            transaction_secret: (0, config_1.getLocale)() === 'en-GB' ? transactionSecret : undefined,
            userId
        }),
        headers: requestHeaders,
        method: 'POST'
    };
    return (0, fluture_1.attemptP)(() => (0, isomorphic_fetch_1.default)(commercetools_1.paymentFormProfileUrl, fetchOptions))
        .pipe(fluture_utils_1.verifyResponse)
        .pipe((0, fluture_1.chain)(fluture_utils_1.attemptBody))
        .pipe((0, fluture_1.map)(monet_1.Maybe.fromNull))
        .pipe((0, fluture_1.chainRej)(perimeterX_1.default));
};
exports.paymentFormProfileFetch = paymentFormProfileFetch;
//# sourceMappingURL=paymentForm.js.map